import type { PayloadAction } from '@reduxjs/toolkit';
import type { CounterDataType, SidePanelCounterType } from './types';

const reducers = {
  updateSidebarCounter: (state: SidePanelCounterType, action: PayloadAction<CounterDataType>) => {
    if (!state.counter) {
      state.counter = [];
    }

    if (!Array.isArray(state.counter)) {
      state.counter = [state.counter];
    }

    const counterArray = state.counter as CounterDataType[];
    const existingIndex = counterArray.findIndex((item) => item.key === action.payload.key);

    if (existingIndex >= 0) {
      counterArray[existingIndex].count = action.payload.count;
    } else {
      counterArray.push({ key: action.payload.key, count: action.payload.count });
    }
  },
  updateScheduleWoCountByMarkets: (
    state: SidePanelCounterType,
    action: PayloadAction<Record<string, number>>,
  ) => {
    state.scheduleWoCountByMarkets = action.payload;
  },
};

export default reducers;
